module.exports = __webpack_public_path__ + "ae837906e219ff5bb590c1308c0a55e3.svg";